import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLanguage } from "@/i18n";
import { Reveal } from "@/components/Reveal";
import { TEXTURE_IMAGE } from "@/data/projects";

export default function About() {
  const { t } = useLanguage();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="about" ref={ref} className="bg-bone py-24 md:py-32 border-t border-ebony/10" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid md:grid-cols-12 gap-12 md:gap-16 items-center">
        <Reveal className="md:col-span-6 order-2 md:order-1">
          <p className="text-xs uppercase tracking-[0.3em] text-terracotta mb-4">{t.about.overline}</p>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tighter text-ebony" data-testid="about-title">
            {t.about.title}
          </h2>
          <p className="mt-6 text-sm md:text-base font-light leading-relaxed text-ebony/70 max-w-lg">{t.about.body}</p>
          <div className="mt-12 grid grid-cols-3 gap-6">
            {t.about.stats.map((s) => (
              <div key={s.label} className="border-l-2 border-ochre pl-4">
                <div className="font-serif text-4xl md:text-5xl font-light text-terracotta">{s.value}</div>
                <div className="mt-1 text-xs uppercase tracking-[0.2em] text-ebony/50">{s.label}</div>
              </div>
            ))}
          </div>
        </Reveal>
        <Reveal className="md:col-span-6 order-1 md:order-2" delay={0.1}>
          <div className="relative overflow-hidden rounded-md h-96 md:h-[34rem]">
            <motion.img
              src={TEXTURE_IMAGE}
              alt="Shanzu, Kenya"
              style={{ y }}
              className="absolute inset-0 h-full w-full object-cover scale-110"
            />
            <div className="absolute bottom-0 left-0 bg-bone px-6 py-4">
              <span className="text-xs uppercase tracking-[0.25em] text-ebony/70">Shanzu · 4.0°S, 39.7°E</span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
